import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { loadAuthToken } from "./lib/api";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import SubmitRequestPage from "./pages/SubmitRequestPage";
import TrackRequestPage from "./pages/TrackRequestPage";
import BranchesPage from "./pages/BranchesPage";
import PrivacyPage from "./pages/PrivacyPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminRetailersPage from "./pages/AdminRetailersPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminBranchesPage from "./pages/AdminBranchesPage";
import CentralWorkQueuePage from "./pages/CentralWorkQueuePage";
import BranchDashboardPage from "./pages/BranchDashboardPage";
import AdminServicesPage from "./pages/AdminServicesPage";
import AdminStudentsPage from "./pages/AdminStudentsPage";
import RequestWorkspacePage from "./pages/RequestWorkspacePage";
import StorePage from "./pages/StorePage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AdminStorePage from "./pages/AdminStorePage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import PartnerRegisterPage from "./pages/PartnerRegisterPage";
import PartnerLoginPage from "./pages/PartnerLoginPage";
import PartnerDashboardPage from "./pages/PartnerDashboardPage";
import FollowupsPage from "./pages/FollowupsPage";
import AdminCustomersPage from "./pages/AdminCustomersPage";
import CustomerProfilePage from "./pages/CustomerProfilePage";
import ResearchPage from "./pages/ResearchPage";
import ResearchTopicPage from "./pages/ResearchTopicPage";
import AccountsPage from "./pages/AccountsPage";
import { ErrorBoundary } from "./components/ErrorBoundary";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => { loadAuthToken(); }, []);

  return (
    <div className="App min-h-screen flex flex-col bg-slate-50">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main className="flex-1">
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/submit" element={<SubmitRequestPage />} />
              <Route path="/track" element={<TrackRequestPage />} />
              <Route path="/branches" element={<BranchesPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/retailers" element={<AdminRetailersPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/branches" element={<AdminBranchesPage />} />
              <Route path="/central" element={<CentralWorkQueuePage />} />
              <Route path="/branch" element={<BranchDashboardPage />} />
              <Route path="/admin/services" element={<AdminServicesPage />} />
              <Route path="/admin/students" element={<AdminStudentsPage />} />
              <Route path="/workspace/:leadId" element={<RequestWorkspacePage />} />
              <Route path="/store" element={<StorePage />} />
              <Route path="/store/:productKey" element={<ProductDetailPage />} />
              <Route path="/admin/store" element={<AdminStorePage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/partner/register" element={<PartnerRegisterPage />} />
              <Route path="/partner/login" element={<PartnerLoginPage />} />
              <Route path="/partner" element={<PartnerDashboardPage />} />
              <Route path="/followups" element={<FollowupsPage />} />
              <Route path="/admin/customers" element={<AdminCustomersPage />} />
              <Route path="/admin/customers/:id" element={<CustomerProfilePage />} />
              <Route path="/admin/research" element={<ResearchPage />} />
              <Route path="/admin/research/:id" element={<ResearchTopicPage />} />
              <Route path="/admin/accounts" element={<AccountsPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
            </ErrorBoundary>
          </main>
          <Footer />
          <FloatingCTA />
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
